const liveChatModule = (() => {
    function liveChat(elem){
    }

    function openLiveHelp() {
    }

    return {
        init : function () {
            if(typeof window.liveChat != 'function'){
                window.liveChat = liveChat;
                window.openLiveHelp = openLiveHelp;
            }
        }
    };
})();

export default liveChatModule;


// WEBPACK FOOTER //
// ./src/scripts/modules/live-chat.js